import { useMemo, useState } from 'react'

export interface UsePagination {
  pageSize: number
}

export const usePagination = ({ pageSize }: UsePagination) => {
  const [currentPage, setCurrentPage] = useState(1)

  const { startIndex, endIndex } = useMemo((): {
    startIndex: number
    endIndex: number
  } => {
    const start = (currentPage - 1) * pageSize
    const end = start + pageSize

    return { startIndex: start, endIndex: end }
  }, [currentPage, pageSize])

  const totalPages = ({ totalItems }: { totalItems: number }) =>
    Math.ceil(totalItems / pageSize)

  return {
    currentPage,
    setCurrentPage,
    startIndex,
    endIndex,
    totalPages,
  }
}
